export const DiscountTypeEnum = {
    PERCENTAGE: 'percentage',
    FIXED: 'fixed',
};
